export default __webpack_public_path__ + "static/3-cbc300597676d1af9b23a631d8a3515b.jpeg";